import ImageCompare from 'image-compare-viewer';
import Glide from '@glidejs/glide';

document.addEventListener('DOMContentLoaded', () => {

	const element = document.getElementById("image-compare");
	if (element) {
		const options = {
			// UI Theme Defaults
			controlColor: "#FFFFFF",
			controlShadow: true,
			addCircle: false,
			addCircleBlur: true,

			// Label Defaults

			showLabels: true,
			labelOptions: {
				before: 'V14',
				after: 'V15',
				onHover: false
			},

			// Smoothing

			smoothing: true,
			smoothingAmount: 100,

			// Other options

			hoverStart: false,
			verticalMode: false,
			startingPoint: 50,
			fluidMode: false
		};

		new ImageCompare(element, options).mount();

		// run

		const compareImageElementA = document.getElementById("imageA")
		const compareImageElementB = document.getElementById("imageB")
		// check image on load?
		const switchers = document.querySelectorAll('.v15-image-grid-item');
		if (switchers.length) {
			switchers.forEach((s) => {
				s.onclick = (e) => {
					compareImageElementA.src = s.dataset.a;
					compareImageElementB.src = s.dataset.b;
					switchers.forEach((ss) => {
						ss.classList.remove('active');
					})
					s.classList.add('active');
				}
			})
		}
	}

	if (document.querySelectorAll('.v15layout').length) {
		new Glide('.glideA').mount()
		new Glide('.glideB').mount()
	}
});
